import { useOutletContext } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHeader } from "@/components/site/PageHeader";
import { LeadForm } from "@/components/site/LeadForm";
import { InfoRows, MapFrame } from "@/components/home/LocationSection";
import { Reveal } from "@/components/motion/Reveal";
import { waLink } from "@/lib/format";

export default function Contact() {
  const { settings, vehicles } = useOutletContext();
  return (
    <div data-testid="contact-page">
      <PageHeader eyebrow="Contact" lines={["Visit the showroom,", "or send a message."]} sub="Sales, service bookings, spare parts availability — one address, one team. We're on West Canal Road, near Zoom Marquee." />
      <section className="wrap grid gap-14 pb-24 lg:grid-cols-12 sm:pb-32">
        <div className="lg:col-span-5">
          <InfoRows settings={settings} />
          <Reveal delay={0.2} className="mt-8 flex flex-wrap gap-4">
            {settings.map_url && <a href={settings.map_url} target="_blank" rel="noreferrer" data-testid="contact-directions-button" className="btn-crimson">Get Directions <ArrowUpRight className="h-4 w-4" /></a>}
            {settings.whatsapp && <a href={waLink(settings.whatsapp, "Hello West Canal Motors!")} target="_blank" rel="noreferrer" data-testid="contact-whatsapp-button" className="btn-ghost">WhatsApp</a>}
          </Reveal>
          <Reveal className="mt-10" y={30} delay={0.25}>
            <MapFrame settings={settings} className="h-[340px]" />
          </Reveal>
        </div>
        <Reveal className="lg:col-span-7" y={40}>
          <LeadForm type="enquiry" vehicles={vehicles} settings={settings} />
        </Reveal>
      </section>
    </div>
  );
}
